<template>
  <div class="marginCarousel" >
    <div class="marginCarousel-body">
      <swipe v-if="list.length > 1" :auto="4000">
        <mt-swipe-item class="slide1" v-for="(item, key) in list" :key="key">
          <img :src="item.icon" @click="clickOpen(item)">
        </mt-swipe-item>
      </swipe>
      <template v-else-if="list.length == 1"><img :src="list[0].icon" @click="clickOpen(list[0])"></template>
    </div>
  </div>
</template>

<script>
import { cblockItem } from '@/api/app'
import Swipe from './swipe/Swipe'
export default {
  name: 'ScrollBar',
  components: { Swipe },
  props: ['list'],
  data () {
    return {
    }
  },
  methods: {
      clickOpen: function(item){
        cblockItem(item, this)
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.marginCarousel{
  padding: 8px 0 8px 0;
}
.marginCarousel-body{
  margin: 0 16px;
}
.marginCarousel-body>img{
  width: 100%;
}
.mint-swipe {
  height: 160px;
  color: #fff;
  font-size: 30px;
  text-align: center;
}
.mint-swipe-item {
  line-height: 160px;
}
.marginCarousel-body img{
    border-radius: 12px;
    max-height: 100%;
    min-width: 100%;
}
</style>
